(() => {
  if (window.__htpfClickAwayClose) return;
  window.__htpfClickAwayClose = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let scrollTimer;

  const topViewportOffset = () => {
    let offset = 8;

    document
      .querySelectorAll('sticky-header, .section-header, .header-wrapper, .shopify-section-group-header-group')
      .forEach((element) => {
        const style = window.getComputedStyle(element);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;

        const rect = element.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top > 4) return;

        offset = Math.max(offset, rect.bottom + 8);
      });

    return offset;
  };

  const scrollOpenDropdownToTop = (trigger) => {
    if (!mobileQuery.matches || trigger.getAttribute('aria-expanded') !== 'true') return;

    const field = trigger.closest('.htpf-field') || trigger.closest('.htpf-combobox');
    if (!field) return;

    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      if (!mobileQuery.matches || trigger.getAttribute('aria-expanded') !== 'true') return;

      const top = field.getBoundingClientRect().top + window.scrollY - topViewportOffset();

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
      });
    }, 80);
  };

  const observeMobileDropdown = (trigger) => {
    const observer = new MutationObserver((mutations) => {
      const expandedChanged = mutations.some(
        (mutation) =>
          mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded'
      );

      if (expandedChanged) scrollOpenDropdownToTop(trigger);
    });

    observer.observe(trigger, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });
  };

  const initMobileDropdownPositioning = () => {
    document
      .querySelectorAll('[data-parts-finder-selector] .htpf-trigger')
      .forEach(observeMobileDropdown);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileDropdownPositioning, { once: true });
  } else {
    initMobileDropdownPositioning();
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-parts-finder-selector]').forEach((root) => {
      root.querySelectorAll('.htpf-combobox').forEach((box) => {
        if (box.contains(event.target)) return;

        const trigger = box.querySelector('.htpf-trigger');
        const panel = box.querySelector('.htpf-panel');
        if (!trigger || !panel) return;

        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-open');
        panel.hidden = true;
      });
    });
  });
})();
